// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cgv-accept .cgv-label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-weight: 400;
}

.cgv-link {
  color: #f97316;
  text-decoration: underline;
  font-size: 1.5rem;
  margin-top: 0.2rem;
  text-align: right;
  width: 100%;
}

.form-group.cgv-accept {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.cgv-container {
  padding: 1rem;
}

.cgv-title-h1,
.cgv-title-h2,
.cgv-title-h3 {
  color: #2c3948;
  margin-bottom: 1rem;
}

.cgv-title-h1 {
  font-size: 2.4rem;
}

.cgv-title-h2 {
  font-size: 2rem;
}

.cgv-title-h3 {
  font-size: 1.8rem;
  margin-top: 1.5rem;
}

.modal-overlay-cgv {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container-cgv {
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    "header"
    "content"
    "footer";
}

.modal-header-cgv {
  grid-area: header;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.modal-content-cgv {
  grid-area: content;
  padding: 24px;
  border-radius: 5vh;
  max-height: 70vh;
  margin: 0 auto 1rem auto;
  width: 95%;
  overflow: hidden;
}

.modal-footer-cgv {
  grid-area: footer;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
}

.scroll-hint-container {
  /* min-height: 22px; */
  height: 40px;
  text-align: center;
}

.scroll-hint-cgv {
  color: #f97316;
  font-size: 1.8rem;
  padding-bottom: 20px;
}

.scroll-hint-cgv.hidden {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
}

/* Barre de progression du défilement */
.scroll-progress-container {
  height: 24px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 15px;
  position: relative;
  overflow: hidden;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.scroll-progress-bar {
  height: 100%;
  background: linear-gradient(to right, #f97316, #e08950);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.scroll-progress-text {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2c3948;
  font-size: 1.4rem;
  font-weight: 500;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);
}

.footer-actions-cgv {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.checkbox-label-cgv {
  display: flex;
  gap: 0.7rem;
  font-size: 1.6rem;
  color: #2c3948;
  cursor: pointer;
}

.checkbox-label-cgv input {
  margin-right: 0.5rem;
  width: 20px;
  height: 20px;
  accent-color: #2c3948;
  cursor: pointer;
}

.cgv-iframe {
  width: 100%;
  height: 60vh;
  padding: 10px;
  border-radius: 3vh;
  overflow-y: auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/composants/CGVAccept/CGVAccept.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;EACzC,aAAa;EACb,iCAAiC;EACjC;;;YAGU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,uDAAuD;EACvD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC","sourcesContent":[".cgv-accept .cgv-label {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-weight: 400;\n}\n\n.cgv-link {\n  color: #f97316;\n  text-decoration: underline;\n  font-size: 1.5rem;\n  margin-top: 0.2rem;\n  text-align: right;\n  width: 100%;\n}\n\n.form-group.cgv-accept {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.cgv-container {\n  padding: 1rem;\n}\n\n.cgv-title-h1,\n.cgv-title-h2,\n.cgv-title-h3 {\n  color: #2c3948;\n  margin-bottom: 1rem;\n}\n\n.cgv-title-h1 {\n  font-size: 2.4rem;\n}\n\n.cgv-title-h2 {\n  font-size: 2rem;\n}\n\n.cgv-title-h3 {\n  font-size: 1.8rem;\n  margin-top: 1.5rem;\n}\n\n.modal-overlay-cgv {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-container-cgv {\n  background-color: #fff;\n  padding: 2rem;\n  border-radius: 8px;\n  max-width: 600px;\n  width: 90%;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  grid-template-areas:\n    \"header\"\n    \"content\"\n    \"footer\";\n}\n\n.modal-header-cgv {\n  grid-area: header;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.modal-content-cgv {\n  grid-area: content;\n  padding: 24px;\n  border-radius: 5vh;\n  max-height: 70vh;\n  margin: 0 auto 1rem auto;\n  width: 95%;\n  overflow: hidden;\n}\n\n.modal-footer-cgv {\n  grid-area: footer;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 1rem;\n}\n\n.scroll-hint-container {\n  /* min-height: 22px; */\n  height: 40px;\n  text-align: center;\n}\n\n.scroll-hint-cgv {\n  color: #f97316;\n  font-size: 1.8rem;\n  padding-bottom: 20px;\n}\n\n.scroll-hint-cgv.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease;\n}\n\n/* Barre de progression du défilement */\n.scroll-progress-container {\n  height: 24px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.scroll-progress-bar {\n  height: 100%;\n  background: linear-gradient(to right, #f97316, #e08950);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.scroll-progress-text {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #2c3948;\n  font-size: 1.4rem;\n  font-weight: 500;\n  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\n}\n\n.footer-actions-cgv {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.checkbox-label-cgv {\n  display: flex;\n  gap: 0.7rem;\n  font-size: 1.6rem;\n  color: #2c3948;\n  cursor: pointer;\n}\n\n.checkbox-label-cgv input {\n  margin-right: 0.5rem;\n  width: 20px;\n  height: 20px;\n  accent-color: #2c3948;\n  cursor: pointer;\n}\n\n.cgv-iframe {\n  width: 100%;\n  height: 60vh;\n  padding: 10px;\n  border-radius: 3vh;\n  overflow-y: auto;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
